export default "__VITE_ASSET__BdwBsAJA__"